/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
import './bootstrap';
import '../sass/app.scss';

import Vue from 'vue/dist/vue.js';
window.Vue = Vue;

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */


import './vue_components';

//This forces the reload of the page when the user uses the back button
$(window).on('popstate', function() {
	location.reload();
});

const app = new Vue({
    el: '#app'
});

window.appReady = true;
window.dispatchEvent(new Event('app:ready'));
